module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/imgBG_Exclusive-b382e813812fae847475d986214b8f80.png";